<template>
    <div class="package-item package-item--additional" :class="{ 'package-item--draft': draftLine }">
        <h3 class="package-title">{{ name }}</h3>
        <ul class="package-item__ul">
            <li class="package-info">
                <p class="feature-desc" v-html="description"></p>
                <p class="feature-name" >
                     {{ duration }}
                </p>
            </li>
        </ul>
        <footer class="package-item__footer">
            <p class="price price--additional">{{ price.value }} <span class="currency">{{ price.label }}</span></p>

            <template v-if="draftLine">
                <div class="draft-actions">
                    <button class="red-button draft-actions__btn" @click="resumeDraft">{{ $t('buttons.continueDraft') }}</button>
                    <button class="outline-button draft-actions__btn" @click="deleteDraft">{{ $t('buttons.deleteDraft') }}</button>
                </div>
            </template>

            <template v-else>
                <button v-if="!recurring || (!active && recurring)" class="red-button"
                        :disabled="disabled"
                        @click="openModal(id)"
                >
                    {{ $t('buttons.activate') }}
                </button>

                <button v-if="active && recurring" class="red-button"
                        @click="openDeactivateModal(id)"
                >
                    {{ $t('buttons.deactivate') }}
                </button>
            </template>
        </footer>
    </div>
</template>

<script>
import Package from './Package';
export default Package;
</script>

<style scoped>
button.red-button:disabled {
    background: #ccc;
    cursor: not-allowed;
    opacity: 0.7;
}

.package-item--draft {
    background-color: #fff8f0;
    border-color: #f5a623;
}

.draft-actions {
    display: flex;
    gap: 8px;
    width: 100%;
}

.draft-actions__btn {
    flex: 1;
    margin-top: 0;
}

.outline-button {
    background: transparent;
    border: 2px solid #c0001a;
    color: #c0001a;
    padding: 8px 16px;
    border-radius: 4px;
    cursor: pointer;
    font-weight: 600;
}

.outline-button:hover {
    background: #c0001a;
    color: #fff;
}
</style>
